import type { ParticipantWithBooker } from "../../types/general";
import type { bookEventDTO } from "./book-event.dto";

export function convertToDTOAttendees(attendees: ParticipantWithBooker[]): bookEventDTO[] {
  return attendees.map(attendee => ({
    first_name: attendee.firstName,
    last_name: attendee.lastName,
    is_booker: attendee.isBooker,
    email: attendee.email,
    phone: attendee.phone,
    gender: attendee.gender,
    // message: attendee.message,
  }));
}
